import * as React from 'react';
import $ from "jquery"
import { useState } from 'react';

const SecondaryContent = (props) => {

  const [checkedBoxes, setCheckedBoxes] = useState({
    seen: false,
    heard: false,
    smelled: false,
    felt: false
  });

  const isAnyCheckboxChecked = () => {
    return Object.values(checkedBoxes).some(value => value);
  };

  const handleCheckboxChange = (id) => {
    const updatedCheckboxes = { ...checkedBoxes };
    updatedCheckboxes[id] = !updatedCheckboxes[id];
    setCheckedBoxes(updatedCheckboxes);
    props.updateCheckboxes(updatedCheckboxes);
  };


  //console.log('props', props);

  // Check which of the two thank you content should we display
  let allNoAnswers = true;
  ['q0Ans', 'q1Ans', 'q2Ans', 'q3Ans'].forEach(ansId => {
    if (props.patientAnswers[ansId] === 'yes') {
      allNoAnswers = false;
    }
  });

  const returnTitlebuttons = () => {
    if (props.endOfShow || props.position > 4) return;

    if (props.position === -1) {
      return (
        <>
          <h2>{props.contentfulContent.intro_question}</h2>
        </>
      )
    }
    if (props.section === 'patient' && props.position > -1) {
      return (
        <>
          <div className="images">
            <div className="images__container d-flex justify-content-center justify-content-lg-start">
              {props.content.images.map((img, index) =>
                <img src={`https:${img}`} key={index} alt='' />
              )}
            </div>
          </div>
          {props.position !== 4 &&
            <h2 className={"small mb-2 question-" + props.position}>
              {`Question ${props.position + 1}:`}
            </h2>
          }

          {props.position !== 2 &&
            <h2 className='small'>{props.content.patient_statement}</h2>
          }

          {props.position === 2 &&
            <div className="answers-hallucinations">
              <h2 className="small part-1">In the past month, have you:</h2>
              <input
                type="checkbox"
                id="seen"
                checked={checkedBoxes.seen}
                onChange={() => handleCheckboxChange('seen')}
              />
              <label htmlFor="seen">seen,</label>
              <input
                type="checkbox"
                id="heard"
                checked={checkedBoxes.heard}
                onChange={() => handleCheckboxChange('heard')}
              />
              <label htmlFor="heard">heard,</label>
              <input
                type="checkbox"
                id="smelled"
                checked={checkedBoxes.smelled}
                onChange={() => handleCheckboxChange('smelled')}
              />
              <label htmlFor="smelled">smelled, or</label>
              <input
                type="checkbox"
                id="felt"
                checked={checkedBoxes.felt}
                onChange={() => handleCheckboxChange('felt')}
              />
              <label htmlFor="felt">physically felt</label>
              <h2 className="small part-2">
                things that you or other people around you did not think were real?
              </h2>
            </div>
          }
        </>
      )
    }
    if (props.section === 'caregiver' && props.position > -1) {
      return (
        <>
          <div className="images">
            <div className="images__container d-flex justify-content-center justify-content-lg-start">
              {props.content.images.map((img, index) =>
                <img src={`https:${img}`} key={index} alt='' />
              )}
            </div>
          </div>
          <h2 className='small purple'>{props.content.caregiver_statement}</h2>
        </>
      )
    }
  }

  const returnButtons = () => {
    if (props.position === -1) {
      return (
        <div className={'ddg-secondary-content__container d-flex flex-column ' + props.section}>
          <button className='ddg-button' onClick={() => props.setSection("patient")}>{props.contentfulContent.intro_button_patient}</button>
        </div>
      )
    }
    if (props.endOfShow && !props.thankyou) {
      return (
        <div className={'ddg-secondary-content__container d-flex flex-column thank-you ' + props.section + (!allNoAnswers ? ' yes-answer' : ' all-no-answers')}>
          <button className='ddg-button' onClick={() => {
            props.changePosition("forward", "yes")
            props.generatePDF('email');
          }} disabled={!props.enableEmailBtn || !props.emailValid}>{!allNoAnswers ? props.contentfulContent.slide_end_email_guide : "Email my results"}</button>
          <button className='ddg-button' onClick={() => {
            props.changePosition("forward", "yes")
            props.generatePDF('print');
          }} disabled={!props.enablePrintBtn}>{!allNoAnswers ? props.contentfulContent.slide_end_skip_and_print : "Skip and print my results"}</button>
          <p className="disclaimer">
            &copy;2023 International Parkinson and Movement Disorder Society (MDS). All rights reserved. Used with
            permission. This scale may not be copied, distributed or otherwise used in whole
            or in part without prior written consent of MDS.
          </p>
        </div>
      )
    }
    if (props.position == 4) {
      return (
        <div className={'ddg-secondary-content__container d-flex flex-column flex-sm-row ' + props.section}>
          <button className="ddg-button" onClick={() => props.changePosition("forward", "Patient in person")}>Patient in person</button>
          <button className="ddg-button" onClick={() => props.changePosition("forward", "Caregiver in person")}>Caregiver in person</button>
          <button className="ddg-button" onClick={() => props.changePosition("forward", "Patient via telemedicine")}>Patient via telemedicine</button>
          <button className="ddg-button" onClick={() => props.changePosition("forward", "Caregiver via telemedicine")}>Caregiver via telemedicine</button>
        </div>
      )
    }
    if ((props.endOfShow && props.thankyou) || props.position === 6) {
      return (
        <>
          {!allNoAnswers && <>
            <div className={'ddg-secondary-content__container d-flex flex-column align-items-center ' + props.section}>
              <div>
                <p class="btnTitle">Looking for a treatment specialist who knows about Parkinson’s disease?</p>
                <a
                  target=""
                  rel="noopener noreferrer"
                  href="next-steps#locate-a-specialist"
                  className='ddg-button fullBtn'
                  onClick={(e) => {
                    // Stop the href link functionality
                    e.stopPropagation();
                    props.startOver();
                    document.getElementById('ddg-modal').style.display = 'none';
                    document.querySelectorAll(".modal-backdrop").forEach(el => el.remove());
                    document.querySelectorAll(".modal-open").forEach(el => el.classList.remove("modal-open"));
                    document.getElementById('ddg-modal').style.display = 'none';
                  }}
                >Find a specialist</a>
              </div>
              <div>
                <p class="btnTitle">Click below to learn about a treatment option for PD-related hallucinations and delusions.</p>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.nuplazid.com"
                  className='ddg-button learnAboutTreatmentDDGButton fullBtn mb-0'
                  onClick={() => {
                    props.startOver();
                    document.getElementById('ddg-modal').style.display = 'none';
                    document.querySelectorAll(".modal-backdrop").forEach(el => el.remove());
                  }}
                >Learn about a treatment option</a>
              </div>
            </div>
          </>}
        </>
      )
    }
    if (props.position >= 0) {
      return (
        <div className={'ddg-secondary-content__container d-flex flex-column flex-sm-row ' + props.section}>
          <button
            className="ddg-button"
            onClick={() => props.changePosition("forward", "yes")}
            // disabled={props.position === 2 && !isAnyCheckboxChecked()}
          >
            {props.contentfulContent.button_yes}
          </button>
          <button
            className="ddg-button"
            onClick={() => props.changePosition("forward", "no")}
          >
            {props.contentfulContent.button_no}
          </button>
          <button
            className="ddg-button"
            onClick={() => props.changePosition("forward", "never")}
            // disabled={props.position === 2 && !isAnyCheckboxChecked()}
          >
            {props.contentfulContent.button_experienced_before}
          </button>
        </div>
      )
    }
  }

  return (
    <>
      <div className={'ddg-secondary-content col-12 col-lg-6 offset-lg-1 mb-3 d-flex flex-column justify-content-center align-items-center align-items-lg-start ' + (allNoAnswers && props.position === 6 ? 'hide' : '' + " title-" + props.position)}>
        {returnTitlebuttons()}
        <div className={props.section}>
          {returnButtons()}
        </div>
      </div>
    </>
  )
}

export default SecondaryContent;